<template>
  <div
    class="nt-wrap-component"
    :class="cssClasses"
    :style="style"
    :id="anchorId"
    :data-id="id"
  >
    <div class="ct-large" :style="{ backgroundColor: backgroundColor }">
      <div class="tabs" ref="tabs">
        <div
          class="tabs__header"
          ref="tabheader"
          :class="{ 'swiper-container': isMobile }"
        >
          <span class="swiper-button-next"></span>
          <div
            class="tabs__header-wrapper"
            :class="{ 'swiper-wrapper': isMobile }"
          >
            <div
              class="tabs__item inner_tab"
              :class="{
                'swiper-slide-active': tabId === item.id,
                'swiper-slide': isMobile,
              }"
              @click="toggleTab(item.id, item.text)"
              tabindex="0"
              :data-id="item.id"
              v-for="item in jsonItems"
              @keydown.enter="toggleTab(item.id, item.text)"
              role="button"
            >
              <input type="hidden" class="tab-item__section" :value="section" />
              <div :style="itemStyles" v-html="item.text"></div>
            </div>
          </div>
          <span class="swiper-button-prev"></span>
        </div>
        <slot v-bind="computedTabsContext" />
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'

export default {
  name: 'nt-tabs',
  provide() {
    return {
      tabContext: () => this.computedTabsContext,
    }
  },
  props: {
    id: String,
    cssClasses: String,
    backgroundColor: String,
    tabItems: String,
    cssStyle: String,
    anchorId: String,
    section: String,
    textWrap: Boolean,
  },
  computed: {
    jsonItems() {
      return JSON.parse(this.tabItems)
    },
    computedTabsContext() {
      return {
        selectedTab: this.tabId,
      }
    },
    itemStyles() {
      return {
        whiteSpace: this.textWrap ? 'normal' : 'nowrap',
        lineHeight: this.textWrap ? '1.2rem' : undefined,
        paddingInline: this.textWrap ? '0.8rem' : undefined
      }
    }
  },
  data() {
    return {
      tabId: '',
      swiper: null,
      isMobile: true,
    }
  },
  created() {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('hashchange', () => {
      const hashId = window.location.hash.replace(/#/g, '')
      this.toggleTab(hashId)
    })
  },
  mounted() {
    const firstTab = this.jsonItems ? this.jsonItems[0].id : null
    const hashId = window.location.hash.replace(/#/g, '')
    this.tabId = hashId || firstTab
    this.toggleTab(this.tabId)
    this.toggleSwiper()
  },
  methods: {
    toggleTab(id, text) {
      this.tabId = id

      if (!text) return

      window.dataLayer.push({
        event: 'click',
        name: text || '',
        section: this.section || 'tab-section',
        component_type: 'texto',
        outbound: false,
      })
    },
    onResize() {
      this.isMobile = this.checkMobile()
      this.toggleSwiper()
    },
    toggleSwiper() {
      const initialTabIndex = this.getTabIndexByTabId(this.tabId)
      this.destroySwiper()
      if (this.isToAddSwiper()) {
        this.swiper = new Swiper(this.$refs.tabheader, {
          loop: true,
          speed: 400,
          centeredSlides: true,
          slidesPerView: 1,
          initialSlide: initialTabIndex,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            transitionEnd: () => {
              const container = document.querySelector(
                `[data-id="${this.id}"]`
              )
              const activeSlide = container.querySelector(
                '.swiper-slide-active'
              )
              const id = activeSlide.dataset.id
              this.toggleTab(id)
            },
          },
        })
      }
    },
    isToAddSwiper() {
      return this.checkMobile() && this.swiper === null
    },
    destroySwiper() {
      if (this.swiper !== null) {
        this.swiper.destroy()
        this.swiper = null
      }
    },
    getTabIndexByTabId(tabId) {
      const container = document.querySelector(`[data-id="${this.id}"]`)
      const tabs = container.querySelectorAll('.tabs__content')
      const tab = container.querySelector(`[id="${tabId}"]`)
      return Array.from(tabs).indexOf(tab)
    },
    checkMobile() {
      const query = '(max-width: 1199px)'
      const media = window.matchMedia(query)
      this.isMobile = media.matches
      return this.isMobile
    },
  },
}
</script>
